document.addEventListener("DOMContentLoaded", async function () {
  const geoInfo = document.getElementById("geo-info");
  const currencySelector = document.getElementById("currency-selector");
  const languageSelector = document.getElementById("language-selector");

  // API Keys (substitua com suas chaves)
  const GEO_API_KEY = "a2e46aa17702484aa38641a3b9738081"; // Ex: ipgeolocation.io ou ipstack
  const EXCHANGE_API_KEY = "90e3f390736f5fdf3dfb170d"; // Ex: exchangerate-api.com ou openexchangerates.org

  // Obter localização por IP
  async function getGeoLocation() {
    const response = await fetch(`https://api.ipgeolocation.io/ipgeo?apiKey=${GEO_API_KEY}`);
    const data = await response.json();
    return {
      country: data.country_name,
      currency: data.currency.code,
      language: data.languages.split(",")[0], // Pega o primeiro idioma listado
    };
  }

  // Obter taxas de câmbio
  async function getExchangeRates(baseCurrency) {
    const response = await fetch(`https://v6.exchangerate-api.com/v6/${EXCHANGE_API_KEY}/latest/${baseCurrency}`);
    const data = await response.json();
    return data.conversion_rates; // Retorna as taxas de câmbio
  }

  // Preencher seletor de moedas
  async function populateCurrencySelector(baseCurrency) {
    const rates = await getExchangeRates(baseCurrency);

    // Limpar e popular o seletor
    currencySelector.innerHTML = "";
    for (const [currency, rate] of Object.entries(rates)) {
      const option = document.createElement("option");
      option.value = currency;
      option.textContent = `${currency} (${rate.toFixed(2)})`;
      currencySelector.appendChild(option);
    }
  }

  // Atualizar interface com base na geolocalização
  try {
    const locationData = await getGeoLocation();

    // Atualizar informações de localização
    geoInfo.textContent = `Detectamos que você está em ${locationData.country}. Moeda local: ${locationData.currency}.`;

    // Configurar idioma
    languageSelector.value = locationData.language;

    // Configurar moedas
    await populateCurrencySelector(locationData.currency);

    // Aplicar automaticamente a moeda e o idioma detectados
    applyCurrency(locationData.currency);
    applyLanguage(locationData.language);
  } catch (error) {
    geoInfo.textContent = "Não foi possível detectar sua localização.";
    console.error(error);
  }

  // Troca de moeda manual
  currencySelector.addEventListener("change", function () {
    applyCurrency(this.value);
  });

  // Troca de idioma manual
  languageSelector.addEventListener("change", function () {
    applyLanguage(this.value);
  });

  // Função para aplicar a moeda
  function applyCurrency(currency) {
    fetch(`/localization/currency`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ currency }),
    }).then(() => window.location.reload());
  }

  // Função para aplicar o idioma
  function applyLanguage(language) {
    fetch(`/localization`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ locale: language }),
    }).then(() => window.location.reload());
  }
});
